import React from "react";
import { IPage } from "../../../../interfaces/models/models/paginated-response.model";
import { IPaginationPayload } from "../../../../interfaces/shared/IPaginationPayload";
import Table from "../../../../shared/table";
import moment from "moment";
import { IRoomRequests } from "../../../../interfaces/room-requests/IRoomRequests";
import MakeCall from "../../reservations/MakeCall";

const tableColumns = [
  "Call",
  "Rooms Request Id",
  "Room Id",
  "Room number",
  "Request",
  "Date",
];

interface IRoomRequestTable {
  rows: IRoomRequests[];
  paginationData?: IPage;
  rowsLoading: boolean;
  setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
}

const RoomRequestTable = ({
  rows,
  paginationData,
  rowsLoading,
  setPaginationState,
}: IRoomRequestTable) => {
  return (
    <Table
      columns={tableColumns}
      paginationData={paginationData}
      setPaginationState={setPaginationState}
    >
      {rowsLoading ? (
        <>
          {[...Array(4)].map((x, i) => {
            return (
              <tr key={i}>
                {[...Array(tableColumns?.length || 1)].map((x, j) => {
                  return (
                    <td key={j} className="td-1 !min-w-[100%] text-center py-5">
                      <span></span>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </>
      ) : (
        <>
          {rows?.length > 0 &&
            rows?.map((row, idx: number) => {
              return (
                <tr key={idx} className="bg-white border-b hover:bg-gray-50">
                  <td className="px-6 py-4">
                    {row.client && (
                      <MakeCall
                        customer={row.client.name}
                        phoneNumber={row.client.phone}
                      />
                    )}
                  </td>
                  <td className="px-6 py-4">
                    <div className="w-20 break-words">{row?._id}</div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="w-20 break-words">{row.roomId}</div>
                  </td>
                  <td className="px-6 py-4">{row.roomNumber}</td>
                  <td className="px-6 py-4">{row.request}</td>
                  <td className="px-6 py-4">
                    {moment(row?.updatedAt).format("DD/MM/YYYY HH:mm")}
                  </td>
                </tr>
              );
            })}
        </>
      )}
    </Table>
  );
};

export default RoomRequestTable;
